import { Component} from '@angular/core'
import { Title } from '@angular/platform-browser';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, Event } from '@angular/router';


// import { AngularFireAuth } from '@angular/fire/auth';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'Admin Portal'
  loading: boolean;

  // user: firebase.User | null = null;

  // constructor(public auth: AngularFireAuth) {}
  // ngOnInit() {
  //   this.loginAnonymously();
  //   this.auth.authState.subscribe(user => {
  //     this.user = user;
  //   });
  // }

  // async loginAnonymously() {
  //   try {
  //     await this.auth.signInAnonymously();
  //   } catch (error) {
  //     console.error('Error logging in anonymously:', error);
  //   }
  // }
  constructor(titleService: Title, private router: Router) {
    
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        var title = this.getTitle(router.routerState, router.routerState.root).join('-');
        titleService.setTitle(`${this.title} ${title ? "|" : ""} ${title}`);
      }
    });
    this.router.events.subscribe((event: Event) => {
      switch (true) {
        case event instanceof NavigationStart: {
          this.loading = true;
          break;
        }

        case event instanceof NavigationEnd:
        case event instanceof NavigationCancel:
        case event instanceof NavigationError: {
          this.loading = false;
          break;
        }
        default: {
          break;
        }
      }
    });
  }
  getTitle(state, parent) {
    var data = [];
    if (parent && parent.snapshot.data && parent.snapshot.data.title) {
      data.push(parent.snapshot.data.title);
    }

    if (state && parent) {
      data.push(... this.getTitle(state, state.firstChild(parent)));
    }
    return data;
  }
}
